import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from 'react-router-dom';
import { Primary } from '../buttons/Primary';


export function ModalRenovarCupo({ isOpen , doc, messageDialog, redirect}) {
    const [open, setOpen] = useState(isOpen);
    const navigate = useNavigate();
    

    const handleClose = (e, r) => {
        if (r === 'backdropClick') {
            return
        }
        setOpen(false);
    };

    const handleRedirect = () => {
        return navigate(redirect)
    }

   
    return (
        <div>

            <Dialog
                disableEscapeKeyDown={true}
                open={open}
                onClose={(e, r) => handleClose(e, r)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle style={{fontWeight: 'bold'}} id="alert-dialog-title">
                    {"Estimado cliente"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{fontWeight: 'normal', color: 'GrayText'}} id="alert-dialog-description">
                        {messageDialog}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    
                    <Button className=" border border-transparent rounded-full shadow-sm text-xl font-medium text-white bg-green transition duration-300 hover:bg-greenDark focus:outline-none" style={{fontWeight: 'bold'}} autoFocus onClick={handleRedirect}>
                        Pagar ahora
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}